import { ApplicationRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { Product, ProductDepot, Supplier } from 'depoto-core/src/entities'
import { ModalContainerComponent } from '../../_common/modal-container/modal-container.component'
import { CoreService, NotificationService } from '../../../services'
import { TranslateService } from '@ngx-translate/core'
import * as Sentry from '@sentry/angular-ivy'
import { CompanyUtilService } from '../../../services/company-util.service'

@Component({
  selector: 'modal-stock-positions',
  templateUrl: 'modal-stock-positions.component.html',
  styleUrls: ['modal-stock-positions.component.scss'],
})
export class ModalStockPositionsComponent {
  @ViewChild('modal') public childModal: ModalContainerComponent
  @Input() productDepot: ProductDepot
  @Input() btnXs = false
  @Input() stock: any
  @Input() public suppliers: Supplier[] = []
  @Input() public product: Product
  @Output() result: EventEmitter<any> = new EventEmitter()
  position1 = ''
  position2 = ''
  position3 = ''
  purchasePrice = 0
  supplier = ''
  batch = ''
  expirationDate = ''
  inventoryQuantityStock = 0
  loading = false
  keyEventSubscriptions: any = {}
  constructor(
    private appRef: ApplicationRef,
    private core: CoreService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    public companyUtil: CompanyUtilService,
  ) {}

  updatePosition(): void {
    this.loading = true
    this.productDepot.position1 = this.position1
    this.productDepot.position2 = this.position2
    this.productDepot.position3 = this.position3
    try {
      this.core.services.product.updateProductDepotPart({
        id: this.productDepot.id,
        position1: this.productDepot.position1,
        position2: this.productDepot.position2,
        position3: this.productDepot.position3,
        purchasePrice: this.productDepot.purchasePrice,
        batch: this.productDepot.batch,
        supplier: this.productDepot.supplier,
        expirationDate: this.productDepot.expirationDate,
      })
      this.notificationService.success(this.translateService.instant('alert.position.update'))
      this.result.emit(true)
      this.hideChildModal()
    } catch (err) {
      console.log(err)
    } finally {
      this.loading = false
    }
  }
  loadPositionFromDepot(): void {
    if (!this.productDepot) {
      return
    }
    this.position1 = this.productDepot.position1
    this.position2 = this.productDepot.position2
    this.position3 = this.productDepot.position3
  }

  showChildModal(): void {
    this.loadPositionFromDepot()
    this.keyEventSubscriptions.keyEsc = this.core.services.keyEvent.onKeyEsc
      .subscribe()
      .then(() => this.hideChildModal())
    this.keyEventSubscriptions.scannedPositions = this.core.services.keyEvent.onScannedPositions
      .subscribe()
      .then(positions => {
        this.position1 = positions[0]
        this.position2 = positions[1]
        this.position3 = positions[2]
        this.appRef.tick()
      })
    this.childModal.showChildModal()
  }

  hideChildModal(): void {
    if (this.keyEventSubscriptions.keyEsc) {
      this.keyEventSubscriptions.keyEsc.unsubscribe()
      this.keyEventSubscriptions.keyEsc = null
    }
    if (this.keyEventSubscriptions.scannedPositions) {
      this.keyEventSubscriptions.scannedPositions.unsubscribe()
      this.keyEventSubscriptions.scannedPositions = null
    }
    this.childModal.hideChildModal()
  }
}
